export default __webpack_public_path__ + "static/media/92.f8b92dca.jpg";